$mol_view_tree2_to_js_test_ex_structural_complex_key_foo $mol_object
	dictionary *
		\raw data key
			\1
		\key2
			\2
		key3
			\3
